import localhost from "../../../apis/localhost";
import { setIsSharepointEnabled } from "../sharepointSlice";

export const fetchSharepointEnabled = () => async (dispatch) => {
  try {
    const { data } = await localhost.get("/sharepoint/enabled");
    dispatch(setIsSharepointEnabled(data));
  } catch (error) {
    console.error(error);
  }
};
